"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyToolbox = exports.MY_TOOLBOX_PATH = void 0;
require("../../../scss/updateAccountInformation.scss");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const constants_1 = require("../../../constants");
const InventoryCard_1 = __importDefault(require("./InventoryCard"));
exports.MY_TOOLBOX_PATH = "/my-toolbox";
const MyToolbox = () => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    return (react_1.default.createElement("div", { className: "boutik-customer-account-my-toolbox-container" },
        react_1.default.createElement("h1", { className: "boutik-customer-account-my-toolbox-title" }, t("customerAccount.myToolbox.sectionTitle")),
        react_1.default.createElement("div", { className: 'boutik-customer-account-my-toolbox-secondary-container' },
            react_1.default.createElement("div", { className: 'boutik-customer-account-my-toolbox-card-container' },
                react_1.default.createElement(InventoryCard_1.default, null)))));
};
exports.MyToolbox = MyToolbox;
//# sourceMappingURL=MyToolbox.js.map